import { GetOrgSettings } from '../gql/leadGenQueries.gql'
import apolloClient from '~/util/apolloClient'
const { provider } = apolloClient()

export default {
  fetchOrgSettings (context) {
    const orgGuid = context.state.orgGuid
    const orgType = context.state.orgType

    provider.clients.defaultClient.query({
      query: GetOrgSettings,
      variables: {
        orgGuid: orgGuid,
        orgType: orgType
      }
    }).then(({ data: { publicData: { organization } } }) => {
      context.commit('setSettings', {
        loanOfficerTitle: organization.lead_gen_setting_loan_officer_title
      })
    }).catch(() => {
      context.commit('setSettings', {
        loanOfficerTitle: null
      })
    })
  }
}
